module.exports = __webpack_public_path__ + "img/super-bonus-popup-ar.2de589f6.gif";